import type { FaireProductEntity } from "../../entity_types/product";

export const p_fva7rcfv9t: FaireProductEntity = {
  token: "p_fva7rcfv9t",
  type: "product",
  name: "AR Embroidered Mock-Neck Sweatshirt",
  brandToken: "b_xwhpw468rz",
  brandName: "Social Statement",
  imageUrl:
    "https://cdn.faire.com/fastly/b538a08e54e477bb18a8712eeb5a1d543d4be910dbdf10f8e67b158e1452851f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6cbd87dcf637651fd88eadfbf602c8ac60ebfb9bfec22914fbf1bde072633aa2.jpeg",
    "https://cdn.faire.com/fastly/c9d2b796d34f9b3d83c25cc1e46123dd06fbcc6f13ec6f372696a125a23aa112.jpeg",
    "https://cdn.faire.com/fastly/166fdcc2d9551a3461c022cbcacf8790771c97591bf3113fc509e6b0127bc6a1.jpeg",
  ],
  priceDollars: 28,
  description:
    "Our AR Embroidered Mock-Neck Sweatshirt is a standout piece from Social Statement, an all-women owned business from the vibrant college town of Fayetteville, Arkansas. This sweatshirt, fitting like a large/x-large, is adorned with exquisite embroidery, reflecting our specialty in creating unique apparel for greek, gameday, and everyday wear. It's more than just a sweatshirt, it's a statement piece that you'll love to wear. Enjoy the comfort and style it brings to your activewear collection.",
  tags: [],
  msrpDollars: 68,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:24:24.740Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
